const movies = [
  { rank: 1, title: '流浪地球 3', enTitle: 'The Wandering Earth III', tag: '科幻巨制', hot: '9.6', year: '2026', desc: '人类命运与星际远征的终极篇章，视觉奇观震撼升级' },
  { rank: 2, title: '哪吒之魔童闹海', enTitle: 'Nezha: The Devil Child Rises', tag: '动画神作', hot: '9.5', year: '2025', desc: '国漫巅峰续作，票房口碑双丰收的现象级作品' },
  { rank: 3, title: '封神第二部', enTitle: 'Creation of the Gods II', tag: '史诗奇幻', hot: '9.4', year: '2026', desc: '神话史诗的恢弘续章，东方魔幻视觉盛宴' },
  { rank: 4, title: '奥本海默', enTitle: 'Oppenheimer', tag: '传记历史', hot: '9.3', year: '2023', desc: '诺兰执导的原子弹之父传记，IMAX 级震撼体验' },
  { rank: 5, title: '沙丘 2', enTitle: 'Dune: Part Two', tag: '科幻史诗', hot: '9.2', year: '2024', desc: '维伦纽瓦打造的沙漠星球传奇，视听语言巅峰' },
  { rank: 6, title: '热辣滚烫', enTitle: 'YOLO', tag: '励志喜剧', hot: '9.1', year: '2024', desc: '贾玲导演力作，笑中带泪的自我蜕变故事' },
  { rank: 7, title: '周处除三害', enTitle: 'The Pig, the Snake and the Pigeon', tag: '犯罪动作', hot: '9.0', year: '2024', desc: '台湾犯罪片黑马，暴力美学与人性探讨并重' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-trophy-fill text-accent-400 text-xs"></i></span>
            <span className="text-xs text-accent-400 font-medium whitespace-nowrap">实时榜单</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">热映榜单</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">夜猫影迷票选最新热门电影推荐，每周更新一次排名</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {movies.map((m, i) => (
            <a
              key={m.title}
              href="#ranking"
              className="group flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer border border-background-200/50 hover:border-primary-500/20"
            >
              <div className={`w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full font-bold text-sm ${
                i < 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-200 text-foreground-400'
              }`}>
                {m.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-medium text-foreground-100 whitespace-nowrap">{m.title}</h3>
                  <span className="text-xs text-foreground-500 hidden sm:inline">{m.enTitle}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-500/10 text-primary-400 whitespace-nowrap">{m.tag}</span>
                </div>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-1 hidden sm:block">{m.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-star-fill text-primary-400 text-xs"></i></span>
                  <span className="text-sm font-bold text-primary-400">{m.hot}</span>
                </div>
                <p className="text-[10px] text-foreground-500">{m.year}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}